// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__25fpM","blink1":"Loader_blink1__2pVH4","blink2":"Loader_blink2__3bvRq","record":"Loader_record__2F0B7","spin":"Loader_spin__1X-nh"};